export const historyBack = (): void => {
  window.history.back();
};
